export default {
    drawImage(data, position = [
        [0],
        [0]
    ], size = [
        [100],
        [100]
    ], text = [], callback) {
        let base64 = [];
        const scale = window.devicePixelRatio; // 设备的devicePixelRatio
        let c = document.createElement('canvas');
        let ctx = c.getContext('2d');
        c.width = size[0][0] * scale;
        c.height = size[1][0] * scale;
        //背景图宽高（第一张为背景图）
        ctx.scale(scale, scale);
        ctx.rect(0, 0, c.width * scale, c.height * scale);
        ctx.fillStyle = '#fff';
        ctx.fill();
        drawing(0);

        function drawing(n) {
            let len = data.length;
            if (n < len) {
                let img = new Image;
                img.src = data[n];
                if (n == 0) {
                    img.onload = function() {
                        ctx.drawImage(img, position[0][n], position[1][n], size[0][n], size[1][n]); //(img_name,left,top,width,height)
                        ctx.font = "13px microsoft yahei"; //设置画笔的字体大小和格式
                        ctx.fillStyle = "rgba(255,255,255,1)"; //设置字体的颜色
                        ctx.fillText(text[0], position[0][len], position[1][len]); //将文字信息画在画布上，按照x,y的坐标，在手机上坐标不是很准确
                        ctx.fillText(text[1], position[0][len + 1], position[1][len + 1]);
                        drawing(n + 1); //递归
                    }
                } else if (n == 1) {
                    img.onload = function() {
                        ctx.drawImage(img, position[0][n], position[1][n], size[0][n], size[1][n]);
                        drawing(n + 1); //递归
                    }
                } else {
                    img.onload = function() {
                        ctx.drawImage(img, position[0][n], position[1][n], size[0][n], size[1][n]);
                        drawing(n + 1); //递归
                    }
                }
            } else {
                //保存生成作品图片
                base64.push(c.toDataURL("image/jpeg", 0.8));
                callback(base64);
            }
        }
    },

}


// WEBPACK FOOTER //
// ./src/utils/drawImage.js